import React,{Component} from "react";
import { adminservice } from "../../services/admin.service";
import { historypush } from "../../_helpers/utilities";
import DataTable from 'react-data-table-component';
import Loader from "../../_helpers/Loader";

const DatatableStyle={
    table: {
        style: {
            //minHeight: '720px', // override the row height
            maxHeight: '720px',
        },
    },
}

class QuestionBank extends Component{
    constructor(props){
        super(props);
        this.state={
            isLoading:false,
            selectedCategory:'1',
            category:[],
            selectedSubCategory:'0',
            subCategory:[],
            documentList:[],
            unfilteredDocumentList:[],
        }
    }

    componentDidMount=async() =>{
        this.getDropDownValues();
        this.getQuestionBankValues();
    }

    /* <summary>
    date: 15-07-2022
    Name: VD
    description: This is used to get the category values
    <summary>*/ 
    getDropDownValues=async()=>{
        try{
            var response = await adminservice.GetCategoryAndSubCategoryList();
            if(response.status === 200){
                this.setState({
                    category:response.data,
                    unfilteredCategory:response.data,
                },async()=>{
                    this.bindSubCategory(1);
                })
            }else if(response.status===401){
                localStorage.clear();
                historypush('/login');
            }
        }catch(e){
            return "";
        }
    }

    /* <summary>
    date: 15-07-2022
    Name: VD
    description: This is used to bind the subcategory
    <summary>*/ 
    bindSubCategory=(categoryId)=>{
        const{category, }=this.state;

        var filteredSubCategory = category.filter((item)=>item.categoryID === categoryId);

        this.setState({
            subCategory:filteredSubCategory[0].subCategoryModels,
        })

    }

    /* <summary>
    date: 15-07-2022
    Name: VD
    description: This is used to get the list of Question banks
    <summary>*/ 
    getQuestionBankValues=async()=>{
        try{
            this.setState({
                isLoading:false,
            })
            var response = await adminservice.GetQuestionBankList();
            if(response.status === 200){
                this.setState({
                    documentList:response.data,
                    unfilteredDocumentList:response.data,
                    isLoading:false,
                })
            }else{
                this.setState({
                    isLoading:false,
                })
            }
            
        }catch(e){
            return "";
        }
    }

    documentHeader = [
        {
          name: <th >Sr.No</th>,
          selector: (row) => row.srno,
          center: true,
        },
        {
          name: <th className="question-doc">Document Names</th>,
          selector: (row) =><div key={row.questionBankID}>
            <span className="view" id={row.questionBankID} > {row.documentName}</span> 
            </div>,
          left: true,
          grow:3,
        },
        {
          name: <th >View</th>,
          selector: (row) =><a className="view" 
                            onClick={()=>this.openFile(row)} style={{ cursor: "pointer",paddingLeft:'13px'}}>
                                View
                            </a>,
          center: true,
        },
        // {
        //   name: <th >Edit</th>,
        //   selector: (row) =><td className="download" onClick={()=>this.selectQuestionId(row)} style={{cursor:'pointer'}}><i className="fa fa-pencil-square-o" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal"/></td>,
        //   center: true,
        // },
    ];

    openFile=(row)=>{
        let filePath=row.documentFilePath;
        if(filePath !== ""){
          window.open(filePath, "_blank");
        }
    }

    OnEventChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        },async()=>{
            this.filterQuestionBank();
        })
    }

    filterQuestionBank=async()=>{
        try{
            const{
                selectedCategory,
                selectedSubCategory,
                unfilteredDocumentList
            }=this.state;
            this.setState({isLoading:true});
            if(selectedSubCategory == '0'){
                this.setState({
                    isLoading:false,
                    documentList:unfilteredDocumentList,
                });
            }else{
                const list = unfilteredDocumentList.filter((item)=>item.subCategoryID == Number(selectedSubCategory));

                this.setState({
                    isLoading:false,
                    documentList:list,
                });
            }
        }catch(e)
        {
            return ""
        }
    }

    goBack=()=>{
        historypush('/memberportal');
    }

    render(){
        const{
            isLoading,
            category,
            subCategory,
            documentList,
            selectedCategory,
            selectedSubCategory,
        }=this.state;
        return(
            <div className="member-body">
                {isLoading && <Loader />}
                <div className="about">
                <div className="container">
                    <h2 className="heading">Question Bank</h2>
                    {/* <span className="filter-option">Filter by</span> */}
                    <div className="col-xl-7 col-lg-8 col-md-11 col-12">
                    <table className="table">
                        <tbody>
                        <tr>
        
                        <td className="about-filter about-filter-mob"><p>Category</p></td>
                          <td className="about-filter-mob" >
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-3" 
                                aria-label=".form-select-lg example"
                                value={selectedCategory}
                                name="selectedCategory"
                                onChange={this.OnEventChange.bind(this)}
                            >
                            {category.map((item)=>{
                                    return(
                                        <option value={item.categoryID}>{item.categoryName}</option>
                                    )
                                })}
                            </select>
                            </td>
                          
                        
                            <td className="about-filter-mob blank-mob"/>
                            <td className="about-filter-mob blank-mob" />
                            <td className="about-filter about-filter-mob "><p>Sub Category</p></td>
                            <td className="about-filter-mob">
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-3" 
                                aria-label=".form-select-lg example"
                                value={selectedSubCategory}
                                name="selectedSubCategory"
                                onChange={this.OnEventChange.bind(this)}
                            >
                                <option value='0'>All</option>
                            {subCategory.map((item)=>{
                                    return(
                                        <option value={item.subCategoryID}>{item.subCategoryName}</option>
                                    )
                                })}
                            </select>
                            </td>
                          
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <div className="table-responsive">
                    {/* <table className="table question-table">
                        <thead className="quest-table-head">
                        <tr>
                            <th className="sr-no">Sr No</th>
                            <th className="question-doc">Document Names</th>
                            <th />
                            <th />
                        </tr>
                        </thead>
                        <tbody className="quest-table-body">
                        <tr className="blue-color">
                            <td className="sr-no">1</td>
                            <td>Document 1</td>
                            <td><a href='https://imare.in/media/11575/634544348474360000QB_EKG_ClII.pdf' target='_blank'>View</a></td>
                            <td className="download"><i className="fa fa-download" /></td>
                        </tr>
                        </tbody>
                    </table> */}
                    <DataTable
                        columns={this.documentHeader}
                        data={documentList}
                        noHeader={true}
                        fixedHeader={true}
                        fixedHeaderScrollHeight="450px"
                        pagination
                        customStyles={DatatableStyle}
                    />
                    </div>
                    <button type="button" onClick={()=>this.goBack()} className="question-button btn btn-white">Back</button>
                </div>
                </div>
            </div>
        )
    }
}

export default QuestionBank;